import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useEffect } from "react";

/**
 * items: [{ href, label }] — first is typically { href:"/", label:"Accueil" }.
 * Last item is displayed non-cliquable (current page).
 * Also injects BreadcrumbList schema.org JSON-LD.
 */
export default function Breadcrumbs({ items = [] }) {
  useEffect(() => {
    if (!items.length) return;
    const base = "https://venteaterme.fr";
    const ld = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.label,
        item: `${base}${it.href}`,
      })),
    };
    let node = document.getElementById("breadcrumb-jsonld");
    if (!node) {
      node = document.createElement("script");
      node.type = "application/ld+json";
      node.id = "breadcrumb-jsonld";
      document.head.appendChild(node);
    }
    node.textContent = JSON.stringify(ld);
    return () => { if (node) node.remove(); };
  }, [items]);

  if (!items.length) return null;

  return (
    <nav
      aria-label="Fil d’Ariane"
      data-testid="breadcrumbs"
      className="text-xs text-navy/60 flex items-center flex-wrap gap-1.5 mb-6"
    >
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.href + i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={12} className="text-navy/30" aria-hidden="true" />}
            {last ? (
              <span className="text-navy/70 font-medium" aria-current="page">{it.label}</span>
            ) : (
              <Link to={it.href} className="hover:text-accent-brand transition-colors">{it.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
